import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface SuggestedQuestionButtonProps {
  [key: string]: any;
  onClick: () => void;
  question: string;
}

export const SuggestedQuestionButton = ({
  question,
  onClick,
  className,
  ...rest
}: SuggestedQuestionButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    className={classNames(
      "focus-visible:!outline-secondary transition-colors duration-200 focus-visible:!outline focus-visible:!outline-2 focus-visible:!outline-offset-2 disabled:cursor-not-allowed",
      "border-primary border",
      "text-secondary",
      "hover:bg-tertiary",
      "disabled:border-gray-300 disabled:text-gray-400 disabled:opacity-50 disabled:hover:bg-transparent",
      "whitespace-normal",
      "rounded-[1.25rem]",
      "px-3.5 py-2",
      "text-left",
      "text-sm font-medium leading-5",
      "dark:text-dark dark:disabled:border-gray-600 dark:disabled:text-gray-500",
      className,
    )}
    {...rest}
  >
    {question}
  </button>
);
